import RolesEditor from "./RolesEditor";

export default RolesEditor;
